import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class CustomerAddressService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    ListCustomerAddress(id) {
        return this.baseApiFactory.getData<any>('/api/CustomerAddress', {id});
    }

    InsertCustomerAddress(value) {
        return this.baseApiFactory.post<boolean>('/api/CustomerAddress', value);
    }

    UpdateCustomerAddress(value) {
        return this.baseApiFactory.put<boolean>('/api/CustomerAddress', value);
    }

    DeleteCustomerAddress(id: number) {
        return this.baseApiFactory.delete<boolean>('/api/CustomerAddress/' + id);
    }
}

lazyRegister.service('CustomerAddressService', CustomerAddressService);